import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getFornitori from "../services/getFornitori";
import MyModal from "../widgets/MyModal";
import checkToken from "../services/checkToken";
import deleteFornitore from "../services/deleteFornitore";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
let userTypeCookies = cookies.get('userType', { path: '/' });

export default class Fornitori extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
      isLoading: true,
      modalAdd: {
        show: false,
      },
      modalEdit: {
        show: false,
        id:'',
      },
    };

  }

  close = () => {
    let modalAdd = this.state.modalAdd;
    modalAdd.show = false;
    let modalEdit = this.state.modalEdit;
    modalEdit.show = false;
    this.setState({ modalAdd, modalEdit });
  }

  async reload() {
    this.setState({ isLoading: true });
    
    this.fornitori = await getFornitori(username, token);

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);

    this.setState({ isLoading: false, isUserType: (userType === 0 || userType === 4) });
  }

  async componentDidMount(){
    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });
    userTypeCookies = cookies.get('userType', { path: '/' });
    await this.reload();
  }

  async delete(row) {
    if (window.confirm('Sei davvero sicuro di volere eliminare questo fornitore?')) {
      const res = await deleteFornitore(username, token, row);
      if (res.result === 'ok') {
        window.location.reload();
        return;
      }

      alert('Errore nella cancellazione del fornitore');
    }
  }


  render () {

    if (this.state.isLoading)
        return <Loading />;

    var headCells = [
      { id: 'ragione_sociale', numeric: false, disablePadding: true, label: 'Fornitore' },
      { id: 'p_iva', numeric: true, disablePadding: false, label: 'P.IVA/Cod. Fiscale' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['ragione_sociale', 'p_iva'];

    return (
      <div id={Math.random()}>

        {
          this.state.isUserType && <PageTitle title="Fornitori" button={"CREA NUOVO"} onClick={() => {
            let x = {
                show: true
              };
            this.setState({ modalAdd: x });
          }}/>
        }

        {
          !this.state.isUserType && <PageTitle title="Fornitori" />
        }

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.fornitori}
          onDelete={this.delete.bind(this)}
          onEventClick={(row) => {
            let x = {
              show: true,
              id: row
            };
          this.setState({ modalEdit: x });
          }}

        />

          {
            this.state.modalAdd.show && <MyModal modal={this.state.modalAdd} title={"Nuovo Fornitore"} onClose={this.close} onReload={()=>this.reload()} isUserType={this.state.isUserType} />
          }
          {
            this.state.modalEdit.show && <MyModal modal={this.state.modalEdit} title={ this.state.isUserType ? "Modifica Fornitore" : "Informazione Fornitore"} onClose={this.close} onReload={()=>this.reload()} isUserType={this.state.isUserType} />
          }
      </div>
    );
  }
}

